const estoqueRoutes = [
  {
    path: '/estoque/movimentacao',
    name: 'estoque.movimentacao',
    component: () => import('../views/estoque/Movimentacao.vue'),
  },
  {
    path: '/estoque/balanco',
    name: 'estoque.balanco',
    component: () => import('../views/estoque/Balanco.vue'),
  },
  {
    path: '/estoque/posicao',
    name: 'estoque.posicao',
    component: () => import('../views/estoque/Posicao.vue'),
  },

];

export default estoqueRoutes;
